import { render, staticRenderFns } from "./StoryMaker.vue?vue&type=template&id=11ee4c45&scoped=true"
import script from "./StoryMaker.vue?vue&type=script&lang=js"
export * from "./StoryMaker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11ee4c45",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('11ee4c45')) {
      api.createRecord('11ee4c45', component.options)
    } else {
      api.reload('11ee4c45', component.options)
    }
    module.hot.accept("./StoryMaker.vue?vue&type=template&id=11ee4c45&scoped=true", function () {
      api.rerender('11ee4c45', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dash/postCreator/components/storyTab/StoryMaker.vue"
export default component.exports